export const FEED_SILENT_TOOLTIP =
  "Cards in this lane stay on the team board but do not appear in organization feeds. Use this for work still being shaped (inbox, backlog, research). You can mark multiple lanes as hidden from feed.";
